import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import LinearProgress from "@mui/material/LinearProgress";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import { useQuery } from "react-query";
import { Dialog } from "../../../../components/Dialog";
import { getParticipants } from "../../../../services/whatsapp";
import { Group } from "../../../../types/whatsapp";
import { PhoneTwo } from "../../../../utils/masks";

type DialogParticipantsProps = {
  open: boolean;
  group?: Group;
  onClose: () => void;
};

function DialogParticipants({ open, group, onClose }: DialogParticipantsProps) {
  const participants = useQuery(
    ["participants", group?.ID],
    () => getParticipants(group?.ID),
    {
      enabled: Boolean(group?.ID),
    }
  );

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      title={group?.NAME}
      onClose={onClose}
    >
      <Stack spacing={1} alignItems="center" justifyContent="center">
        {participants.isLoading ? (
          <>
            <Typography color="GrayText">Buscando participantes...</Typography>
            <LinearProgress sx={{ width: "100%" }} />
          </>
        ) : participants.data && participants.data?.length > 0 ? (
          <>
            <List sx={{ width: "100%" }}>
              {participants?.data?.map((participant) => (
                <>
                  <ListItem alignItems="center">
                    <ListItemAvatar>
                      <Avatar alt={participant.phone} />
                    </ListItemAvatar>
                    <ListItemText primary={PhoneTwo(participant.phone)} />
                  </ListItem>
                  <Divider variant="inset" component="li" />
                </>
              ))}
            </List>
          </>
        ) : (
          <>
            <Typography color="GrayText">
              Não encontramos nenhum participante
            </Typography>
          </>
        )}
      </Stack>
    </Dialog>
  );
}

export default DialogParticipants;
